"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GLWBPageOne;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _GuaranteedLifetimeWithdrawalBenefitWizardFormControls = require("./GuaranteedLifetimeWithdrawalBenefitWizardFormControls");
var _GuaranteedLifetimeWithdrawalBenefitWizardCalc = require("./GuaranteedLifetimeWithdrawalBenefitWizardCalc.config");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function GLWBPageOne() {
  var {
    values: {
      isSingleLife,
      isQualified,
      isNewYork
    },
    errors,
    touched,
    setFieldValue,
    values
  } = (0, _formik.useFormikContext)();
  (0, _react.useEffect)(() => {
    if (values.isNewYork === 'newYork' && !_GuaranteedLifetimeWithdrawalBenefitWizardCalc.dropdownOptions.netGrowthNYArray.includes(values.net_market_growth_rate)) {
      // if values.net_market_growth_rate IS NOT in the range
      // reset to use initial default value
      setFieldValue('net_market_growth_rate', _GuaranteedLifetimeWithdrawalBenefitWizardCalc.initialValuesConfig.net_market_growth_rate);
    }
  }, [values.isNewYork]);

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    /* istanbul ignore next */
    if (values.hasNavigatedPage) {
      document.getElementById(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName).scrollIntoView();
      /* istanbul ignore else */
      if (window) {
        window.scrollBy(0, -112);
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "glwb"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h5", null, "Issue age"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-display"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-12 col-lg-6 align-self-stretch"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-selector"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.SingleLifeRadioButton, {
    isSingleLife: isSingleLife,
    setFieldValue: setFieldValue
  }))), isSingleLife === 'singleLife' ? /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.IssueAge, {
    className: "col-11 mm-tablet-mobile-only",
    id: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.idPrefix + 'issueAge_mobileSingleLife',
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }) : '', /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-12 col-lg-6 align-self-stretch"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-selector"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.JointLifeRadioButton, {
    isSingleLife: isSingleLife,
    setFieldValue: setFieldValue
  }))), isSingleLife === 'jointLife' ? /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.IssueAge, {
    className: "col-11 mm-tablet-mobile-only",
    id: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.idPrefix + 'issueAge_mobileJointLife',
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }) : '')), /*#__PURE__*/_react.default.createElement("div", {
    className: "padding-left-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-box"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.IssueAge, {
    className: "col-6 mm-desktop-only",
    id: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.idPrefix + 'issueAge_desktop',
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.IssueAgeCollapse, {
    openToStart: ''
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("h5", null, "Purchase payment"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-display"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-12 col-lg-6 align-self-stretch"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-selector"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.QualifiedRadioButton, {
    isQualified: isQualified,
    setFieldValue: setFieldValue
  }))), isQualified === 'qualified' ? /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.PurchasePayment, {
    className: "col-11 mm-tablet-mobile-only",
    id: "purchasePayment_mobileQualified",
    errors: errors,
    values: values,
    touched: touched,
    setFieldValue: setFieldValue,
    isQualified: isQualified
  }) : '', /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-12 col-lg-6 align-self-stretch"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-selector"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.NonQualifiedRadioButton, {
    isQualified: isQualified,
    setFieldValue: setFieldValue
  }))), isQualified === 'nonQualified' ? /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.PurchasePayment, {
    className: "col-11 mm-tablet-mobile-only",
    id: "purchasePayment_mobileNonQualified",
    errors: errors,
    values: values,
    touched: touched,
    setFieldValue: setFieldValue,
    isQualified: isQualified
  }) : '')), /*#__PURE__*/_react.default.createElement("div", {
    className: "padding-left-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-box"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.PurchasePayment, {
    className: "col-6 mm-desktop-only",
    id: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.idPrefix + 'purchasePayment_desktop',
    errors: errors,
    values: values,
    touched: touched,
    setFieldValue: setFieldValue,
    isQualified: isQualified
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.PurchasePaymentsCollapse, {
    openToStart: ''
  }))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h5", null, "State of client residence"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-display flex-nowrap"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-selector"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.NewYorkRadioButton, {
    isNewYork: isNewYork,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-selector"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.OtherStateRadioButton, {
    isNewYork: isNewYork,
    setFieldValue: setFieldValue
  }))))))), /*#__PURE__*/_react.default.createElement("br", null));
}